module.exports = __webpack_public_path__ + "static/img/product-3.4df67d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/product-3.png
// module id = l+Qy
// module chunks = 0